import { Feedback } from 'v2/core/entities/feedback';

export const getNoAudioSourceInfoText = (
  sourceV2: Feedback['sourceV2'],
  hasPrefix?: boolean,
) => {
  return `${
    hasPrefix ? 'audio' : 'Audio'
  } playback is not available for feedback from ${
    sourceV2?.name ?? 'this source'
  }`;
};
